import { useT } from '@/i18n/I18nProvider'

interface Integration { id: string; name: string; status: 'connected' | 'available' | 'coming-soon'; description: string }

const INTEGRATIONS: Integration[] = [
  { id: 'github',     name: 'GitHub',     status: 'available',  description: 'Open pull requests with fixes against your repos.' },
  { id: 'gitlab',     name: 'GitLab',     status: 'coming-soon', description: 'PR mode for GitLab-hosted projects.' },
  { id: 'wordpress',  name: 'WordPress',  status: 'available',  description: 'Apply head/footer injects + meta rewrites via the WP REST API.' },
  { id: 'webflow',    name: 'Webflow',    status: 'coming-soon', description: 'Apply via Webflow CMS API.' },
  { id: 'shopify',    name: 'Shopify',    status: 'coming-soon', description: 'Apply meta + structured data via Shopify Admin API.' },
  { id: 'slack',      name: 'Slack',      status: 'coming-soon', description: 'Critical findings → Slack channel.' },
  { id: 'gsc',        name: 'Google Search Console', status: 'available', description: 'OAuth-based ownership verification + impressions data.' },
]

export function IntegrationsPage() {
  const t = useT()
  return (
    <div>
      <h1 className="text-2xl font-semibold mb-1">{t('settings.integrations.title')}</h1>
      <p className="text-sm opacity-70 mb-6">{t('settings.integrations.subtitle')}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {INTEGRATIONS.map((i) => (
          <div key={i.id} className="p-4 rounded border" style={{ borderColor: 'var(--color-border)' }}>
            <div className="flex items-center justify-between">
              <h3 className="font-medium">{i.name}</h3>
              <StatusBadge status={i.status} />
            </div>
            <p className="text-xs opacity-70 mt-1">{i.description}</p>
            {i.status === 'available' && (
              <button
                type="button"
                className="mt-3 text-xs px-2 py-1 rounded border"
                style={{ borderColor: 'var(--color-border)' }}
                disabled
                title="Connect flow ships in a follow-up release"
              >
                {t('settings.integrations.connect')}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

function StatusBadge({ status }: { status: Integration['status'] }) {
  const labels: Record<Integration['status'], { text: string; bg: string }> = {
    connected:    { text: 'Connected',    bg: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200' },
    available:    { text: 'Available',    bg: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200' },
    'coming-soon':{ text: 'Coming soon',  bg: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200' },
  }
  const l = labels[status]
  return <span className={`text-xs px-2 py-0.5 rounded ${l.bg}`}>{l.text}</span>
}
